import React, { useEffect } from "react";
import { Button, Nav } from "rsuite";
import "../styles/navigation.css";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/graphics/logo_white.webp";
import logo_dark from "../assets/graphics/logo_dark.webp";
import NavDrawer from "./Drawer";
import AnnouncementMessage from "./AnnouncementMessage";

const Navbar = ({ active, transparent, navigate, onSelect, ...props }) => {
  return (
    <Nav
      {...props}
      activeKey={active}
      onSelect={onSelect}
      className="navigation"
    >
      <AnnouncementMessage />
      <Nav.Menu eventKey="aboutUs" title="About Us">
        <Nav.Item onClick={() => navigate("/aboutus")}>Who We Are</Nav.Item>
        <Nav.Item onClick={() => navigate("/wherewework")}>
          Where We Work
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/historymilestone")}>
          History / Milestone
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/accountability")}>
          Accountability
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/complaintform")}>
          Complaints & Feedback
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/ourteam")}>Our Team</Nav.Item>
        <Nav.Item onClick={() => navigate("/faq")}>FAQs</Nav.Item>
      </Nav.Menu>

      <Nav.Menu
        eventKey="whatWeDo"
        style={{ color: "#fff" }}
        title="What We Do"
      >
        <Nav.Menu
          eventKey="overview"
          style={{ color: "#fff" }}
          title="Overview"
        >
          <Nav.Item onClick={() => navigate("/overview")}>Overview</Nav.Item>
          <Nav.Item onClick={() => navigate("/programmingapproaches")}>
            KRO Programming Approaches
          </Nav.Item>
        </Nav.Menu>
        <Nav.Item onClick={() => navigate("/livelihoodfoodsecurity")}>
          Livelihood & Food Security
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/wash")}>WASH</Nav.Item>
        <Nav.Item onClick={() => navigate("/cashbasedinterventions")}>
          Cash-based Interventions
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/protection")}>Protection</Nav.Item>
        <Nav.Item onClick={() => navigate("/shelter")}>Shtelter</Nav.Item>
        <Nav.Item onClick={() => navigate("/sbc")}>SBC</Nav.Item>
        <Nav.Item onClick={() => navigate("/childprotection")}>
          Child Protection
        </Nav.Item>
      </Nav.Menu>

      <Nav.Menu
        eventKey="getInvolved"
        style={{ color: "#fff" }}
        title="Get Involved"
      >
        <Nav.Item onClick={() => navigate("/careeropportunities")}>
          Career Oppourtunities
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/rfps")}>RFQs & RFPs</Nav.Item>
      </Nav.Menu>

      <Nav.Menu eventKey="media" style={{ color: "#fff" }} title="Media">
        <Nav.Item onClick={() => navigate("/newsletter")}>News Letter</Nav.Item>
        <Nav.Item onClick={() => navigate("/successstories")}>
          Success Stories
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/photogallery")}>
          Photo Gallery
        </Nav.Item>
        <Nav.Item onClick={() => navigate("/videogallery")}>
          Video Galery
        </Nav.Item>
      </Nav.Menu>

      <Nav.Item
        eventKey="impact"
        onClick={() => navigate("/impact")}
        className="nav-item"
      >
        Impact
      </Nav.Item>
      <Nav.Item
        eventKey="contactUs"
        onClick={() => navigate("/contactus")}
        className="nav-item"
      >
        Contact Us
      </Nav.Item>
      {/* <BTN appearance='primary' size='xs' onClick={()=>window.open('https://kro-af.org/admin','_blank')}>Log In</BTN> */}
    </Nav>
  );
};

const Navigation = ({ transparent }) => {
  const [active, setActive] = React.useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    let nav = document.getElementsByClassName("rs-nav-item");
    Array.from(nav).map((item) => {
      transparent ? (item.style.color = "#fff") : (item.style.color = "#000");
    });
  }, []);

  return (
    <NavContainer trans={transparent}>
      <div onClick={() => navigate("/")} style={{ width: "20%" }}>
        <Image
          src={transparent ? logo : logo_dark}
          alt="Kandahar Refugee Organization Logo"
        />
      </div>
      <NavbarContainer>
        <Navbar
          active={active}
          transparent={transparent}
          navigate={navigate}
          onSelect={setActive}
        />
      </NavbarContainer>
      <DrawerContainer>
        <AnnouncementMessage />
        <NavDrawer />
      </DrawerContainer>
    </NavContainer>
  );
};

export default Navigation;

const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${(props) => (props.trans ? "transparent" : "#f7f7f7")};
  width: 100%;
  height: 120px;
  position: ${(props) => (props.trans ? "absolute" : "relative")};
  z-index: 100;
  padding: 40px;
  @media (max-width: 768px) {
    padding: 20px;
    height: 80px;
  }
`;

let NavbarContainer = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-around;

  @media (max-width: 1260px) {
    display: none;
  }
`;

let DrawerContainer = styled.div`
  display: flex;
  gap: 10px;
  z-index: 105;

  @media (min-width: 1261px) {
    display: none;
  }
`;

const Image = styled.img`
  width: 130px;
  height: 100px;
  position: absolute;
  top: 10px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 80px;
    height: auto;
    position: absolute;
    top: 10px;
  }
`;
